import { useMemo } from "react";
import * as yup from "yup";

import { FormTranslator } from "../../../hooks/useFormTranslator";
import { useValidationResult, useYup } from "../../../hooks/useYup";

export function useCalendarEventSchema(translator: FormTranslator) {
    useYup(translator);

    const validationSchema = useMemo(
        () =>
            yup.object({
                name: yup.string().required(),
                customerLocationId: yup
                    .number()
                    .required()
                    .test(
                        "Cannot be default value",
                        translator
                            .getField("customerLocationId")
                            .getGlobalError("required"),
                        num => num !== -1,
                    ),
                startDate: yup.date().required(),
                endDate: yup.date().required(),
            }),
        [translator],
    );

    return useValidationResult(validationSchema);
}
